module.exports = {
  data: {
    pageAutoWrap: true,
    ops: [],
    isSts: false,
    columns: [
      {
        orderkey: "orgidgrouparmy",
        _index: 0,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.getOrgName",
        dataIndex: "orgidgrouparmy",
        display: "true",
        dbField: "orgidgrouparmy",
        fixed: "left",
        oldWidth: "100px",
        title: "集团军"
      },
      {
        orderkey: "subcompanyidregion",
        _index: 1,
        transMethod: "weaver.hrm.company.SubCompanyComInfo.getSubCompanyname",
        dataIndex: "subcompanyidregion",
        display: "true",
        dbField: "subcompanyidregion",
        fixed: "left",
        oldWidth: "100px",
        title: "大区"
      },
      {
        orderkey: "orgid",
        _index: 2,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.getOrgName",
        dataIndex: "orgid",
        display: "true",
        dbField: "orgid",
        fixed: "left",
        oldWidth: "150px",
        title: "机构"
      },
      {
        orderkey: "twoyearsagoacceptamount0",
        _index: 3,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "twoyearsagoacceptamount0",
        display: "true",
        dbField: "twoyearsagoacceptamount0",
        oldWidth: "15%",
        title: "2017年验收金额（0-10万）"
      },
      {
        orderkey: "twoyearsagoacceptamount10",
        _index: 4,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "twoyearsagoacceptamount10",
        display: "true",
        dbField: "twoyearsagoacceptamount10",
        oldWidth: "15%",
        title: "2017年验收金额（10-30万）"
      },
      {
        orderkey: "twoyearsagoacceptamount30",
        _index: 5,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "twoyearsagoacceptamount30",
        display: "true",
        dbField: "twoyearsagoacceptamount30",
        oldWidth: "15%",
        title: "2017年验收金额（30-50万）"
      },
      {
        orderkey: "twoyearsagoacceptamount50",
        _index: 6,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "twoyearsagoacceptamount50",
        display: "true",
        dbField: "twoyearsagoacceptamount50",
        oldWidth: "15%",
        title: "2017年验收金额（50-80万）"
      },
      {
        orderkey: "twoyearsagoacceptamount80",
        _index: 7,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "twoyearsagoacceptamount80",
        display: "true",
        dbField: "twoyearsagoacceptamount80",
        oldWidth: "15%",
        title: "2017年验收金额（80-100万）"
      },
      {
        orderkey: "twoyearsagoacceptamount100",
        _index: 8,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "twoyearsagoacceptamount100",
        display: "true",
        dbField: "twoyearsagoacceptamount100",
        oldWidth: "15%",
        title: "2017年验收金额（100-200万）"
      },
      {
        orderkey: "twoyearsagoacceptamount200",
        _index: 9,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "twoyearsagoacceptamount200",
        display: "true",
        dbField: "twoyearsagoacceptamount200",
        oldWidth: "15%",
        title: "2017年验收金额（200-万）"
      },
      {
        orderkey: "lastyearacceptamount0",
        _index: 10,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "lastyearacceptamount0",
        display: "true",
        dbField: "lastyearacceptamount0",
        oldWidth: "15%",
        title: "2018年验收金额（0-10万）"
      },
      {
        orderkey: "lastyearacceptamount10",
        _index: 11,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "lastyearacceptamount10",
        display: "true",
        dbField: "lastyearacceptamount10",
        oldWidth: "15%",
        title: "2018年验收金额（10-30万）"
      },
      {
        orderkey: "lastyearacceptamount30",
        _index: 12,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "lastyearacceptamount30",
        display: "true",
        dbField: "lastyearacceptamount30",
        oldWidth: "15%",
        title: "2018年验收金额（30-50万）"
      },
      {
        orderkey: "lastyearacceptamount50",
        _index: 13,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "lastyearacceptamount50",
        display: "true",
        dbField: "lastyearacceptamount50",
        oldWidth: "15%",
        title: "2018年验收金额（50-80万）"
      },
      {
        orderkey: "lastyearacceptamount80",
        _index: 14,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "lastyearacceptamount80",
        display: "true",
        dbField: "lastyearacceptamount80",
        oldWidth: "15%",
        title: "2018年验收金额（80-100万）"
      },
      {
        orderkey: "lastyearacceptamount100",
        _index: 15,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "lastyearacceptamount100",
        display: "true",
        dbField: "lastyearacceptamount100",
        oldWidth: "15%",
        title: "2018年验收金额（100-200万）"
      },
      {
        orderkey: "lastyearacceptamount200",
        _index: 16,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "lastyearacceptamount200",
        display: "true",
        dbField: "lastyearacceptamount200",
        oldWidth: "15%",
        title: "2018年验收金额（200-万）"
      },
      {
        orderkey: "thisyearacceptamount0",
        _index: 17,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "thisyearacceptamount0",
        display: "true",
        dbField: "thisyearacceptamount0",
        oldWidth: "15%",
        title: "2019年验收金额（0-10万）"
      },
      {
        orderkey: "thisyearacceptamount10",
        _index: 18,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "thisyearacceptamount10",
        display: "true",
        dbField: "thisyearacceptamount10",
        oldWidth: "15%",
        title: "2019年验收金额（10-30万）"
      },
      {
        orderkey: "thisyearacceptamount30",
        _index: 19,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "thisyearacceptamount30",
        display: "true",
        dbField: "thisyearacceptamount30",
        oldWidth: "15%",
        title: "2019年验收金额（30-50万）"
      },
      {
        orderkey: "thisyearacceptamount50",
        _index: 20,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "thisyearacceptamount50",
        display: "true",
        dbField: "thisyearacceptamount50",
        oldWidth: "15%",
        title: "2019年验收金额（50-80万）"
      },
      {
        orderkey: "thisyearacceptamount80",
        _index: 21,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "thisyearacceptamount80",
        display: "true",
        dbField: "thisyearacceptamount80",
        oldWidth: "15%",
        title: "2019年验收金额（80-100万）"
      },
      {
        orderkey: "thisyearacceptamount100",
        _index: 22,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "thisyearacceptamount100",
        display: "true",
        dbField: "thisyearacceptamount100",
        oldWidth: "15%",
        title: "2019年验收金额（100-200万）"
      },
      {
        orderkey: "thisyearacceptamount200",
        _index: 23,
        transMethod:
          "com.engine.pms.util.datacenter.PmsReportListTransMethod.changeToThousands",
        dataIndex: "thisyearacceptamount200",
        display: "true",
        dbField: "thisyearacceptamount200",
        oldWidth: "15%",
        title: "2019年验收金额（200-万）"
      },
      {
        dataIndex: "randomFieldId",
        dbField: "randomFieldId",
        from: "set",
        title: "randomFieldId"
      }
    ],
    datas: [
      {
        lastyearacceptamount100span: "0.00",
        twoyearsagoacceptamount80span: "0.00",
        lastyearacceptamount80: "0.0",
        lastyearacceptamount200: "4588860.00",
        twoyearsagoacceptamount100span: "0.00",
        twoyearsagoacceptamount80: "",
        thisyearacceptamount10span: "2,648,600.00",
        lastyearacceptamount0span: "535,888.00",
        randomFieldIdspan: "",
        twoyearsagoacceptamount30span: "0.00",
        thisyearacceptamount100span: "1,300,000.00",
        lastyearacceptamount30span: "2,304,000.00",
        thisyearacceptamount30: "1047200.00",
        subcompanyidregion: "-1",
        thisyearacceptamount200: "7774000.00",
        orgidgrouparmyspan: "第九集团军",
        thisyearacceptamount50span: "500,000.00",
        orgid: "246",
        thisyearacceptamount80: "1838000.00",
        lastyearacceptamount50span: "0.00",
        lastyearacceptamount30: "2304000.00",
        lastyearacceptamount80span: "0.00",
        twoyearsagoacceptamount10: "",
        twoyearsagoacceptamount100: "",
        orgidspan: "第九集团军",
        twoyearsagoacceptamount50: "",
        twoyearsagoacceptamount50span: "0.00",
        thisyearacceptamount30span: "1,047,200.00",
        thisyearacceptamount200span: "7,774,000.00",
        lastyearacceptamount100: "0.0",
        lastyearacceptamount10span: "5,446,120.00",
        twoyearsagoacceptamount0span: "0.00",
        twoyearsagoacceptamount0: "",
        thisyearacceptamount50: "500000.00",
        thisyearacceptamount80span: "1,838,000.00",
        thisyearacceptamount0span: "509,000.00",
        thisyearacceptamount0: "509000.00",
        lastyearacceptamount0: "535888.00",
        thisyearacceptamount10: "2648600.00",
        twoyearsagoacceptamount200span: "0.00",
        subcompanyidregionspan: "",
        orgidgrouparmy: "246",
        lastyearacceptamount50: "0.0",
        lastyearacceptamount200span: "4,588,860.00",
        thisyearacceptamount100: "1300000.00",
        twoyearsagoacceptamount10span: "0.00",
        twoyearsagoacceptamount30: "",
        lastyearacceptamount10: "5446120.00",
        twoyearsagoacceptamount200: "",
        randomFieldId: ""
      },
      {
        lastyearacceptamount100span: "0.00",
        twoyearsagoacceptamount80span: "0.00",
        lastyearacceptamount80: "0.0",
        lastyearacceptamount200: "4588860.00",
        twoyearsagoacceptamount100span: "0.00",
        twoyearsagoacceptamount80: "",
        thisyearacceptamount10span: "1,479,000.00",
        lastyearacceptamount0span: "227,500.00",
        randomFieldIdspan: "",
        twoyearsagoacceptamount30span: "0.00",
        thisyearacceptamount100span: "1,300,000.00",
        lastyearacceptamount30span: "646,000.00",
        thisyearacceptamount30: "0.0",
        subcompanyidregion: "106",
        thisyearacceptamount200: "3774000.00",
        orgidgrouparmyspan: "第九集团军",
        thisyearacceptamount50span: "0.00",
        orgid: "248",
        thisyearacceptamount80: "0.0",
        lastyearacceptamount50span: "0.00",
        lastyearacceptamount30: "646000.00",
        lastyearacceptamount80span: "0.00",
        twoyearsagoacceptamount10: "",
        twoyearsagoacceptamount100: "",
        orgidspan: "新疆机构",
        twoyearsagoacceptamount50: "",
        twoyearsagoacceptamount50span: "0.00",
        thisyearacceptamount30span: "0.00",
        thisyearacceptamount200span: "3,774,000.00",
        lastyearacceptamount100: "0.0",
        lastyearacceptamount10span: "3,131,900.00",
        twoyearsagoacceptamount0span: "0.00",
        twoyearsagoacceptamount0: "",
        thisyearacceptamount50: "0.0",
        thisyearacceptamount80span: "0.00",
        thisyearacceptamount0span: "360,000.00",
        thisyearacceptamount0: "360000.00",
        lastyearacceptamount0: "227500.00",
        thisyearacceptamount10: "1479000.00",
        twoyearsagoacceptamount200span: "0.00",
        subcompanyidregionspan: "泛微--新疆大区",
        orgidgrouparmy: "246",
        lastyearacceptamount50: "0.0",
        lastyearacceptamount200span: "4,588,860.00",
        thisyearacceptamount100: "1300000.00",
        twoyearsagoacceptamount10span: "0.00",
        twoyearsagoacceptamount30: "",
        lastyearacceptamount10: "3131900.00",
        twoyearsagoacceptamount200: "",
        randomFieldId: ""
      },
      {
        lastyearacceptamount100span: "0.00",
        twoyearsagoacceptamount80span: "0.00",
        lastyearacceptamount80: "0.0",
        lastyearacceptamount200: "0.0",
        twoyearsagoacceptamount100span: "0.00",
        twoyearsagoacceptamount80: "",
        thisyearacceptamount10span: "0.00",
        lastyearacceptamount0span: "0.00",
        randomFieldIdspan: "",
        twoyearsagoacceptamount30span: "0.00",
        thisyearacceptamount100span: "0.00",
        lastyearacceptamount30span: "0.00",
        thisyearacceptamount30: "0.0",
        subcompanyidregion: "212",
        thisyearacceptamount200: "0.0",
        orgidgrouparmyspan: "第九集团军",
        thisyearacceptamount50span: "0.00",
        orgid: "1831",
        thisyearacceptamount80: "0.0",
        lastyearacceptamount50span: "0.00",
        lastyearacceptamount30: "0.0",
        lastyearacceptamount80span: "0.00",
        twoyearsagoacceptamount10: "",
        twoyearsagoacceptamount100: "",
        orgidspan: "兰州EBU二部",
        twoyearsagoacceptamount50: "",
        twoyearsagoacceptamount50span: "0.00",
        thisyearacceptamount30span: "0.00",
        thisyearacceptamount200span: "0.00",
        lastyearacceptamount100: "0.0",
        lastyearacceptamount10span: "0.00",
        twoyearsagoacceptamount0span: "0.00",
        twoyearsagoacceptamount0: "",
        thisyearacceptamount50: "0.0",
        thisyearacceptamount80span: "0.00",
        thisyearacceptamount0span: "0.00",
        thisyearacceptamount0: "0.0",
        lastyearacceptamount0: "0.0",
        thisyearacceptamount10: "0.0",
        twoyearsagoacceptamount200span: "0.00",
        subcompanyidregionspan: "泛微--甘肃大区",
        orgidgrouparmy: "246",
        lastyearacceptamount50: "0.0",
        lastyearacceptamount200span: "0.00",
        thisyearacceptamount100: "0.0",
        twoyearsagoacceptamount10span: "0.00",
        twoyearsagoacceptamount30: "",
        lastyearacceptamount10: "0.0",
        twoyearsagoacceptamount200: "",
        randomFieldId: ""
      },
      {
        lastyearacceptamount100span: "0.00",
        twoyearsagoacceptamount80span: "0.00",
        lastyearacceptamount80: "0.0",
        lastyearacceptamount200: "0.0",
        twoyearsagoacceptamount100span: "0.00",
        twoyearsagoacceptamount80: "",
        thisyearacceptamount10span: "524,000.00",
        lastyearacceptamount0span: "75,000.00",
        randomFieldIdspan: "",
        twoyearsagoacceptamount30span: "0.00",
        thisyearacceptamount100span: "0.00",
        lastyearacceptamount30span: "863,000.00",
        thisyearacceptamount30: "345000.00",
        subcompanyidregion: "78",
        thisyearacceptamount200: "4000000.00",
        orgidgrouparmyspan: "第九集团军",
        thisyearacceptamount50span: "0.00",
        orgid: "259",
        thisyearacceptamount80: "1838000.00",
        lastyearacceptamount50span: "0.00",
        lastyearacceptamount30: "863000.00",
        lastyearacceptamount80span: "0.00",
        twoyearsagoacceptamount10: "",
        twoyearsagoacceptamount100: "",
        orgidspan: "宁夏机构",
        twoyearsagoacceptamount50: "",
        twoyearsagoacceptamount50span: "0.00",
        thisyearacceptamount30span: "345,000.00",
        thisyearacceptamount200span: "4,000,000.00",
        lastyearacceptamount100: "0.0",
        lastyearacceptamount10span: "1,150,000.00",
        twoyearsagoacceptamount0span: "0.00",
        twoyearsagoacceptamount0: "",
        thisyearacceptamount50: "0.0",
        thisyearacceptamount80span: "1,838,000.00",
        thisyearacceptamount0span: "81,000.00",
        thisyearacceptamount0: "81000.00",
        lastyearacceptamount0: "75000.00",
        thisyearacceptamount10: "524000.00",
        twoyearsagoacceptamount200span: "0.00",
        subcompanyidregionspan: "泛微--宁夏大区",
        orgidgrouparmy: "246",
        lastyearacceptamount50: "0.0",
        lastyearacceptamount200span: "0.00",
        thisyearacceptamount100: "0.0",
        twoyearsagoacceptamount10span: "0.00",
        twoyearsagoacceptamount30: "",
        lastyearacceptamount10: "1150000.00",
        twoyearsagoacceptamount200: "",
        randomFieldId: ""
      },
      {
        lastyearacceptamount100span: "0.00",
        twoyearsagoacceptamount80span: "0.00",
        lastyearacceptamount80: "0.0",
        lastyearacceptamount200: "0.0",
        twoyearsagoacceptamount100span: "0.00",
        twoyearsagoacceptamount80: "",
        thisyearacceptamount10span: "307,000.00",
        lastyearacceptamount0span: "153,388.00",
        randomFieldIdspan: "",
        twoyearsagoacceptamount30span: "0.00",
        thisyearacceptamount100span: "0.00",
        lastyearacceptamount30span: "350,000.00",
        thisyearacceptamount30: "304200.00",
        subcompanyidregion: "165",
        thisyearacceptamount200: "0.0",
        orgidgrouparmyspan: "第九集团军",
        thisyearacceptamount50span: "0.00",
        orgid: "260",
        thisyearacceptamount80: "0.0",
        lastyearacceptamount50span: "0.00",
        lastyearacceptamount30: "350000.00",
        lastyearacceptamount80span: "0.00",
        twoyearsagoacceptamount10: "",
        twoyearsagoacceptamount100: "",
        orgidspan: "西藏机构",
        twoyearsagoacceptamount50: "",
        twoyearsagoacceptamount50span: "0.00",
        thisyearacceptamount30span: "304,200.00",
        thisyearacceptamount200span: "0.00",
        lastyearacceptamount100: "0.0",
        lastyearacceptamount10span: "926,220.00",
        twoyearsagoacceptamount0span: "0.00",
        twoyearsagoacceptamount0: "",
        thisyearacceptamount50: "0.0",
        thisyearacceptamount80span: "0.00",
        thisyearacceptamount0span: "0.00",
        thisyearacceptamount0: "0.0",
        lastyearacceptamount0: "153388.00",
        thisyearacceptamount10: "307000.00",
        twoyearsagoacceptamount200span: "0.00",
        subcompanyidregionspan: "泛微--西藏大区",
        orgidgrouparmy: "246",
        lastyearacceptamount50: "0.0",
        lastyearacceptamount200span: "0.00",
        thisyearacceptamount100: "0.0",
        twoyearsagoacceptamount10span: "0.00",
        twoyearsagoacceptamount30: "",
        lastyearacceptamount10: "926220.00",
        twoyearsagoacceptamount200: "",
        randomFieldId: ""
      },
      {
        lastyearacceptamount100span: "0.00",
        twoyearsagoacceptamount80span: "0.00",
        lastyearacceptamount80: "0.0",
        lastyearacceptamount200: "0.0",
        twoyearsagoacceptamount100span: "0.00",
        twoyearsagoacceptamount80: "",
        thisyearacceptamount10span: "338,600.00",
        lastyearacceptamount0span: "80,000.00",
        randomFieldIdspan: "",
        twoyearsagoacceptamount30span: "0.00",
        thisyearacceptamount100span: "0.00",
        lastyearacceptamount30span: "445,000.00",
        thisyearacceptamount30: "398000.00",
        subcompanyidregion: "79",
        thisyearacceptamount200: "0.0",
        orgidgrouparmyspan: "第九集团军",
        thisyearacceptamount50span: "500,000.00",
        orgid: "261",
        thisyearacceptamount80: "0.0",
        lastyearacceptamount50span: "0.00",
        lastyearacceptamount30: "445000.00",
        lastyearacceptamount80span: "0.00",
        twoyearsagoacceptamount10: "",
        twoyearsagoacceptamount100: "",
        orgidspan: "青海机构",
        twoyearsagoacceptamount50: "",
        twoyearsagoacceptamount50span: "0.00",
        thisyearacceptamount30span: "398,000.00",
        thisyearacceptamount200span: "0.00",
        lastyearacceptamount100: "0.0",
        lastyearacceptamount10span: "238,000.00",
        twoyearsagoacceptamount0span: "0.00",
        twoyearsagoacceptamount0: "",
        thisyearacceptamount50: "500000.00",
        thisyearacceptamount80span: "0.00",
        thisyearacceptamount0span: "68,000.00",
        thisyearacceptamount0: "68000.00",
        lastyearacceptamount0: "80000.00",
        thisyearacceptamount10: "338600.00",
        twoyearsagoacceptamount200span: "0.00",
        subcompanyidregionspan: "泛微--青海大区",
        orgidgrouparmy: "246",
        lastyearacceptamount50: "0.0",
        lastyearacceptamount200span: "0.00",
        thisyearacceptamount100: "0.0",
        twoyearsagoacceptamount10span: "0.00",
        twoyearsagoacceptamount30: "",
        lastyearacceptamount10: "238000.00",
        twoyearsagoacceptamount200: "",
        randomFieldId: ""
      }
    ],
    haveCheck: false,
    rootMap: {
      tabletype: "none",
      fileName: "分区间验收金额",
      instanceid: "PmsReportList_nearlyrangeamount",
      cssHandler: "com.weaver.cssRenderHandler.request.CheckboxColorRender",
      pagesize: "10",
      pageUid: "PmsReportList_nearlyrangeamount",
      pageId: "PmsReportList_nearlyrangeamount"
    },
    pageSize: "10",
    timeJson: {
      "read data in dao": 31,
      "read data from datasource": 0,
      "do browser": 0,
      last: 0,
      "init Bean": 0,
      "get current user and count page ": 24,
      "all cost": 58,
      "do transMethod in dao": 3,
      "create sql": 0
    },
    status: true
  }
};



// WEBPACK FOOTER //
// ./comMobx/wea-table-new/stores/test-data.js